import { render, staticRenderFns } from "./CreateNewField.vue?vue&type=template&id=363f5c1b&"
import script from "./CreateNewField.vue?vue&type=script&lang=js&"
export * from "./CreateNewField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports